<template>
  <!-- ************* VETRINA DI UN CONSORZIO ********** -->
  <!-- Mostra una pagina descrittiva del consorzio e    -->
  <!-- permette l'acquisto diretto del buono da spendere-->
  <!-- presso i fornitori appartenenti al consorzio.    -->
  <!-- Nessun Articolo viene mostrato in questo caso.   -->
  <div>
    <PageTagline :elements="tagline_elem" />

    <!-- Overlay di caricamento della pagina -->
    <CustomOverlay :show="overlay_show" :text="overlay_text">

      <b-button pill size="sm" @click="torna_ai_fornitori">
        <b-icon icon="caret-left-fill"></b-icon>Torna alle convenzioni
      </b-button>

      <!-- LOGO O NOME DEL CONSORZIO -->
      <!-- v-if info_cons renderizza il logo quando le info del consorzio sono -->
      <!-- state caricate, se non lo usiamo si verifica un errore di rendering -->
      <!-- perchè vue tenta di renderizzare subito informazioni che ancora non -->
      <!-- ha in quanto le infor sul fornitore non sono disponibili da subito  -->
      <b-row class="mt-4" v-if="info_cons">
        <b-col class="text-center">
          <div v-if="info_cons.logo_url">
            <b-img :src="info_cons.logo_url" alt="logo"></b-img>
          </div>
          <div v-else>
            <h3 class="pb-3">{{info_cons.nome}} {{info_cons.cognome}}</h3>
          </div>
        </b-col>
      </b-row>

      <!-- INFORMATIVA -->
      <!-- Poniamo qui tutte le info. I riferimenti di indirizzo, email, -->
      <!-- telefono etc.. e soprattutto la descrizione del consorzio.    -->
      <b-row class="mt-4" v-if="info_cons">
        <!-- Colonna con i riferimenti del consorzio -->
        <b-col md="3" class="pl-md-5">
          <!-- Indirizzo -->
          <h5 class="font-italic">Dove:</h5>
          <h6 class="font-weight-normal">
            <span class="font-italic">
              <span v-if="info_cons.indirizzo">{{info_cons.indirizzo}}</span> {{info_cons.comune}} {{info_cons.cap}} <span class="text-uppercase">({{info_cons.provincia}})</span>
              <b-link class="ml-2" target="_blank" :href="google_map_link" v-b-tooltip.hover.rightbottom="'Vedi in Google Maps'" ><font-awesome-icon icon="map-marker-alt"/></b-link>
            </span>
          </h6>
          <!-- Contatti -->
          <h5 v-if="contacts_not_present" class="font-italic mt-3">Contatti:</h5>
          <!-- Telefono, se presente -->
          <h6 v-if="info_cons.tel" class="font-weight-normal">
            <font-awesome-icon icon="phone-square-alt" class="mr-2"/><i>Telefono:</i> {{info_cons.tel}}
          </h6>
          <!-- Email, se presente -->
          <h6 v-if="info_cons.email" class="font-weight-normal">
            <font-awesome-icon icon="at" class="mr-2"/><i>Email:</i> <b-link :href="'mailto:' + info_cons.email">{{info_cons.email}}</b-link>
          </h6>
          <!-- Sito web, se presente -->
          <h6 v-if="info_cons.sito_web" class="font-weight-normal">
            <font-awesome-icon icon="globe" class="mr-2"/><i>Sito web:</i> <b-link target="_blank" :href="info_cons.sito_web">{{info_cons.sito_web}}</b-link>
          </h6>
        </b-col>
        <!-- Colonna con la descrizione -->
        <b-col class="text-justify pr-md-5">
          <span class="description">{{info_cons.descrizione}}</span>
        </b-col>
      </b-row>
      <!-- BOTTONE PER VISUALIZZARE LA LISTA DEI FORNITORI -->
      <!-- Apre la modale che visualizza la lista dei fornitori fferenti a questo consorzio -->
      <b-row class="mt-4">
        <b-col offset-md="4" md="8">
          <b-link class="show-forn-link" @click="show_forn_modal=true">
            <b-img fluid :src="forn_list_img"></b-img>
          </b-link>
        </b-col>
      </b-row>

      <!-- ACQUISTO DEL BUONO -->
      <b-row class="mt-4">
        <b-col>
          <h4 class="mb-3">Scegli il buono più adatto alle tue esigenze:</h4>
          <p class="text-justify"><i>
            <font-awesome-icon icon="info-circle"/> Ricorda che il valore massimo dei tuoi buoni all'interno di un
            anno fiscale non può superare i 515€. Qualora avessi dubbi relativamente al superamento della soglia
            prevista dall'Art. 51 c.3 del TUIR (515€), visita la pagina <b-link :to="{ 'name' : 'site-normativa' }">Normativa</b-link>
            o inviaci una richiesta di assistenza.
          </i></p>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <!-- FORM DI ACQUISTO -->
          <b-form @submit.prevent="esegui_acquisto">
            <!-- usiamo la row per restringere il campo quando siamo su schermi grandi -->
            <b-row>
              <b-col md="12">
                <p>Scegli l'importo del buono ed accetta le condizioni per proseguire.</p>
              </b-col>
              <b-col md="2">
                <b-form-group id="group-importo"
                  label="Importo:"
                  label-for="importo">
                  <b-form-select id="importo"
                      v-model="importo"
                      :options="tagli_buoni"
                      required></b-form-select>
                </b-form-group>
              </b-col>
            </b-row>
            <b-form-checkbox
              id="check-cond"
              v-model="check_cond"
              name="check-cond"
              :value="true"
              :unchecked-value="false"
              required>
              <i class="text-justify">confermando l'operazione dichiaro che i miei benefit relativi a buoni o altri benefit previsti dall'Art. 51 c.3 del TUIR per l'anno fiscale in corso, non superano i 515€.<br>
              <b class="text-justify">Sono altresì consapevole che in caso di superamento di tale cifra, l'intera somma sarà soggetta a tassazione completa.</b></i>
            </b-form-checkbox>
            <b-button :disabled="btn_status_disabled" variant="primary" class="mt-3 mb-2" type="submit">Acquista</b-button>
            <!-- Avviso di pin identificativo non settato -->
            <p v-if="!pin_exists" class="text-danger font-italic text-justify">
              Attenzione, non hai un pin identificativo valido associato al tuo utente. Senza di esso non potrai riscattare
              il buono presso il fornitore di tua scelta. Per favore genera un pin prima di procedere recandoti in
              <b-link class="pin-page-link" :to="{ name: 'gestione-pin'}">Gestione Pin Utente.</b-link>.
            </p>
            <!-- Avviso di superamento del credito art51c3 -->
            <p v-if="credito_non_suff" class="text-danger font-italic text-justify">
              Attenzione, l'importo supera il tuo attuale credito welfare relativo ai buoni
              ( art51c3 ) che è di {{$store.state.user.user_credito.art51c3}} euro. Non puoi procedere alla richiesta.
            </p>
          </b-form>
        </b-col>
      </b-row>
    </CustomOverlay>

    <!-- MODALE ELENCO FORNITORI -->
    <!-- Una modale per visualizzare l'elenco dei fornitori afferenti al consorzio -->
    <b-modal size="lg"
             id="show-forn-modal"
             v-model="show_forn_modal"
             @show="carica_fornitori_consorzio"
             title="Di seguito la lista delle attività presso il quale potrai spendere il voucher:"
             scrollable>
      <b-overlay :show="show_forn_modal_overlay" spinner-variant="primary">
        <b-table-simple responsive class='mt-4'>
          <b-tbody>
            <b-tr v-for="( fornitore, index ) in forn_by_cons_list" :key="index">
              <b-td>
                <b-row>
                  <!-- Logo del fornitore: viene mostrato se disponibile -->
                  <b-col v-if="fornitore.logo_url" cols="md-2">
                    <b-img fluid class="cons-forn-logo" :src="fornitore.logo_url"></b-img>
                  </b-col>
                  <!-- Info del fornitore -->
                  <b-col>
                    <p>
                      <b-link target="_blank" :href="google_map_fornitore( fornitore )" v-b-tooltip.hover.rightbottom="'Vedi in Google Maps'" >
                        <font-awesome-icon class="ml-1 mr-2" icon="map-marker-alt"/>
                      </b-link>
                      <span class="h6">{{ fornitore.nome }} {{ fornitore.cognome }}</span> -
                      <i>{{ fornitore.indirizzo }} {{ fornitore.comune }} {{ fornitore.cap }} <span v-if="fornitore.provincia">( {{ fornitore.provincia }} )</span></i>
                    </p>
                    <p v-if="fornitore.sito_web">
                      <font-awesome-icon icon="globe" class="ml-1 mr-2"/> <i>Sito web:</i> <b-link target="_blank" :href="fornitore.sito_web">{{fornitore.sito_web}}</b-link>
                    </p>
                  </b-col>
                </b-row>
              </b-td>
            </b-tr>
          </b-tbody>
        </b-table-simple>
      </b-overlay>
      <!-- Personalizziamo il footer con il solo bottone chiudi -->
      <template v-slot:modal-footer="{ hide }">
        <b-button variant="secondary" @click="hide()">Chiudi</b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import PageTagline from '@/components/PageTagline'
import CustomOverlay from '@/components/CustomOverlay'
import { generalLib } from '@/generalLib'
import { apiUrl } from '@/apiUrl'
import axios from 'axios'

export default {
  name: 'VetrinaConsorzio',
  data () {
    return {
      // Nella tagline lasciamo "Vetrina Fornitore", il consorzio è un nostro concetto interno.
      tagline_elem : [ { text : "Convenzioni special", link : 'home-fornitori' },
                       { text : "Vetrina Fornitore", link : '' } ],

      // Test dell'overlay, diverso nella fase di caricamento
      // e acquisto.
      overlay_text : null,

      // Overlay di caricamento della pagina
      overlay_show: false,

      // Flag che indica se l'utente ha un pin valido per il
      // riscatto del buono. Supposto false viene eventualmente
      // settato a true dopo aver chiamato il backend.
      pin_exists : false,

      // Informazioni sul consorzio
      info_cons: null,

      // Importo selezionato per il buono
      importo: 0,

      // Tagli possibili per i buoni, viene riempita
      // al created con i dati presi dal backend.
      tagli_buoni : [
        { value: 0, text: "Seleziona", disabled: true }
      ],

      // Stato della checkbox per le condizioni
      check_cond : false,

      // Flag per la visualizzazione della modale con la lista dei fornitori
      // afferenti al consorzio
      show_forn_modal : false,

      // Visualizza l'overlay di caricamento della modale.
      show_forn_modal_overlay : false,

      // Lista dei fornitori afferenti al consorzio da visualizzare nella modale.
      forn_by_cons_list : [],

      // Immagine per il link alla modale con la lista dei fornitori
      forn_list_img : require('@/assets/conv_special/bottone_lista_fornitori_consorzio.png' )

    }
  },
  computed: {
    /**
     * Sulla base dell'indirizzo del fornitore calcola il
     * link per google maps con l'apposita funzione di libreria.
     */
    google_map_link : function () {
      return generalLib.google_map_link( this.info_cons.comune, this.info_cons.cap,
                                         this.info_cons.provincia, this.info_cons.indirizzo  );
    },
    /**
     * Torna false se nessuno dei contatti ( telefono, email o sito web )
     * è presente.
     */
    contacts_not_present : function () {
      let present = true;
      if ( ( this.info_cons.tel === null || this.info_cons.tel === '' ) &&
           ( this.info_cons.email === null || this.info_cons.email === '' ) &&
           ( this.info_cons.sito_web === null || this.info_cons.sito_web === '' ) ) {
        present = false;
      }
      return present;
    },
    /**
     * Calcola il flag per abilitare disabilitare il pulsante di acquisto.
     * Deve essere stato selezionato il taglio del buono e la checkbox delle condizioni.
     * Il taglio selezionato non deve superare quanto attualmente a disposizione per
     * l'art51c3.
     * L'utente deve eavere un pin identificativo settato altrimenti non riuscirà a
     * riscattare il buono.
     */
    btn_status_disabled : function () {
      let disabled = true;
      if ( !this.credito_non_suff && this.check_cond === true && this.importo > 0 && this.pin_exists ) {
        disabled = false;
      }
      return disabled;
    },
    /**
     * Torna true se l'utente ha sufficiente credito art51c3 a disposizione, altrimenti
     * torna false.
     */
    credito_non_suff : function () {
      if ( this.$store.state.user.user_credito.art51c3 >= this.importo ) {
        return false;
      } else {
        return true;
      }
    }
  },
  methods: {
    /**
     * Torna alla home dei fornitori.
     */
    torna_ai_fornitori : function (){
      this.$router.push( { name : 'home-fornitori' } );
    },
    /**
     * Esegue l'acquisto del buono per il consorzio
     */
    esegui_acquisto : function () {

      // La componente di credito in tal caso è sempre art51c3
      generalLib.acquisto_confirm_message_box (  this, this.importo, 'art51c3' )
      .then( ( value ) => {
        // L'utente ha risposto Annulla.
        if ( !value ) return;

        // Preparo le informazioni da inviare per effettuare l'acquisto e poi lo eseguo
        let data = { id_consorzio : this.id_consorzio, importo : this.importo }

        this.overlay_text = "Richiesta in corso, attendere...";
        this.overlay_show = true;

        axios.post( apiUrl.welfareapi.create_acq_buonowfbit , data )
        .then( (response) => {

          this.overlay_show = false;

          // Visualizza la finestra di completamento, la quale alla chiusura ci riporta
          // alla home.
          generalLib.acquisto_complete_message_box( this, response.data.id_acquisto )
          .then ( () => {
              this.$router.push( { name : 'menu'} );
          });

        })
        .catch( (error) => {
          this.overlay_show = false;
          generalLib.backend_error_message_box( this, error.response.data );
        });

      })
      .catch( ( error ) => {
        console.error( error );
      });
    },
    /**
     * All'apertura della modale per la visualizzazione dei fornitori che afferiscono
     * al consorzio va a caricare questi ultimi per la visualizzazione.
     */
    carica_fornitori_consorzio : function () {

      // Se l'array dei fornitori era stata già inizializzata non
      // la carico di nuovo nelle successive aperture della modale.
      if( this.forn_by_cons_list.length > 0 ) return;

      this.show_forn_modal_overlay = true

      let call_url = apiUrl.fornitoriapi.get_forn_by_consorzio.replace( '@id_consorzio', this.info_cons.id )

      axios.get( call_url )
      .then( ( response ) => {
        this.forn_by_cons_list = response.data;

        // Andiamo ad ordinare alfabeticamente i fornitori per nome
        this.forn_by_cons_list.sort( ( a, b ) => {
          if ( a.nome < b.nome ) return -1;
          if ( a.nome > b.nome ) return 1;
          return 0
        });

        this.show_forn_modal_overlay = false;
      })
      .catch( (error) => {
        this.show_forn_modal_overlay = false;
        generalLib.backend_error_message_box( this, error.response.data );
      });

    },
    /**
     * Dato l'oggetto che rappresenta un fornitore afferente al consorzio ne restituisce
     * il link per google map.
     */
    google_map_fornitore : function ( fornitore ) {
      return generalLib.google_map_link( fornitore.comune, fornitore.cap,
                                         fornitore.provincia, fornitore.indirizzo );
    }
  },
  /**
   * Alla creazione del componente carica i tagli dei buoni acquistabili,
   * le info sul consorzio ed il flag che indica se il pin utente è stato
   * settato per eventualmente andarlo a notificare evitando la creazione
   * del buono.
   */
  created : function () {

    // Devo eseguire le tre richieste in cascata per poter gestire bene la rimozione
    // dell'overlay.
    this.overlay_text = "Caricamento in corso, attendere...";
    this.overlay_show = true;

    // Eseguo prima la chiamata per le info del consorzio poi quella per i tagli dei buoni
    // ed infine per controllare l'asistenza del pin

    // INFO FORNITORE
    let info_cons_call_url = apiUrl.fornitoriapi.get_info_fornitore.replace( '@id_fornitore', this.id_consorzio );

    axios.get( info_cons_call_url )
    .then( ( response ) => {

      // INFO FORNITORE - Setta le info del fornitore
      this.info_cons = response.data;

      // TAGLI BUONI
      axios.get( apiUrl.welfareapi.get_tagli_buoni_wfbit )
      .then( ( response ) => {

        // TAGLI BUONI - Inserisco i tagli dei buoni nella select
        for ( let elem of response.data ) {
          this.tagli_buoni.push( { text : elem + ' €' , value : elem });
        }

        // VERIFICA PIN
        axios.get( apiUrl.welfareapi.pin_identificativo )
        .then( ( response ) => {

          // VERIFICA PIN - Setto l'esistenza del pin o meno
          this.pin_exists = response.data.pin_exists;

          // Fatto tutto! Ora posso togliere l'overlay.
          this.overlay_show = false;

        })
        .catch( ( error ) => {
          this.overlay_show = false;
          let message = "Si è verificato un errore nel caricamento delle informazioni di configurazione, " +
                        "si prega di riprovare, se il problema persiste contattare l'assistenza";
          generalLib.backend_error_message_box( this, message );
          console.error( error.response.data );
        });

      })
      .catch( ( error ) => {
        this.overlay_show = false;
        let message = "Si è verificato un errore nel caricamento delle informazioni di configurazione, " +
                      "si prega di riprovare, se il problema persiste contattare l'assistenza";
        generalLib.backend_error_message_box( this, message );
        console.error( error.response.data );
      });

    })
    .catch( ( error ) => {
      this.overlay_show = false;
      let message = "Si è verificato un errore nel caricamento delle informazioni sul fornitore, " +
                    "si prega di riprovare, se il problema persiste contattare l'assistenza";
      generalLib.backend_error_message_box( this, message );
      console.error( error.response.data );
    });

  },
  props : {
    /**
     * Id del fornitore del quale visualizzare i dati, è necessario
     * fornirlo per poterlo visualizzare.
     */
    id_consorzio: {
      type: [ String, Number ],
      required: true
    }
  },
  components : {
    PageTagline,
    CustomOverlay
  }
}
</script>

<style scoped>
/* Interpreta il testo come preformattato di modo tale
   che eventuali "a capo" siano renderizzati correttamente.
   "wrap" fa poi in modo che il testo vada a capo e non sfori
   oltre il limite di larghezza della colonna.*/
.description {
  white-space: pre-wrap;
}
/* Coloriamo dello stesso rosso della classe text-danger di
  bootstrap il link all'area Genera Pin e la mettiamo più in
  risalto usando il Bold */
.pin-page-link {
  color: #dc3545;
  font-weight: bold;
}

/* Nascondiamo la scroll lungo la x nelle righe della tabella
   andando a ridefinire la overflow-x della class table-responsive
   di bootstrap */
#show-forn-modal .modal-body .table-responsive {
  overflow-x: hidden;
}

/* Stile per il link che apre la modale con l'elenco dei fornitori
   afferenti al consorzio */
.show-forn-link img{
  border-radius: 5px;
}
.show-forn-link:hover img{
  filter: blur(1px);
}

/* Loghi dei fornitori nella lista di fornitori afferenti al consorzio */
.cons-forn-logo {
  max-width: 100px;
  max-height: 100px;
}
</style>